import React, { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { Pagination } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import {
  CircularProgress,
  Divider,
  Container,
  makeStyles,
  Typography,
  CardActionArea,
  useMediaQuery,
  Checkbox,
  IconButton,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import { useQuery, useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import MapIcon from "@material-ui/icons/Map";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import ShareIcon from "@material-ui/icons/Share";
import GavelIcon from "@material-ui/icons/Gavel";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import FiberNewIcon from "@material-ui/icons/FiberNew";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import FavoriteIcon from "@material-ui/icons/Favorite";
import StarIcon from "@material-ui/icons/Star";
import ClearIcon from "@material-ui/icons/Clear";
import { LineShareButton } from "react-share";

import { useAlert } from "../components/Alert";
import Grid from "../components/Grid";
import Table from "../components/Table";
import { CardContent, CardActions } from "../components/Card";
import Text from "../components/Text";
import moment from "moment";
import LoadingModal from "../components/LoadingModal";
import { Select } from "../components/Form";
import { propertyDataArray } from "../components/PropertyDataArray";
import CurrentPopper from "./components/CurrentPopper";
import ErrorLogReport from "./components/ErrorLogReport";
import Map from "./components/Map";

const GET_FORECLOSURES = gql`
  query foreclosures(
    $obj_no: [Int]
    $obj_city: [String]
    $obj_court: String
    $obj_area: [String]
    $obj_address: String
    $obj_caseno: String
    $searchTerm: String
    $obj_date_ymd_from: Date
    $obj_date_ymd_to: Date
    $obj_creat_date_from: Date
    $obj_creat_date_to: Date
    $obj_build_floor_from: Float
    $obj_build_floor_to: Float
    $obj_price_from: Float
    $obj_price_to: Float
    $obj_type: String
    $obj_patterns: [String]
    $obj_time: [String]
    $obj_transfer: String
    $obj_land_data: String
    $obj_build_data: String
    $obj_bulletin_data: String
    $orderBy: OrderBy
    $bid: Boolean
    $source: [String]
    $desc: Boolean
    $pageSize: Int
    $errorLog: Boolean
    $popular: Boolean
    $frontSite: Boolean
    $page: Int
  ) {
    foreclosures(
      obj_no: $obj_no
      obj_city: $obj_city
      obj_court: $obj_court
      obj_area: $obj_area
      obj_address: $obj_address
      obj_caseno: $obj_caseno
      searchTerm: $searchTerm
      obj_date_ymd_from: $obj_date_ymd_from
      obj_date_ymd_to: $obj_date_ymd_to
      obj_creat_date_from: $obj_creat_date_from
      obj_creat_date_to: $obj_creat_date_to
      obj_build_floor_from: $obj_build_floor_from
      obj_build_floor_to: $obj_build_floor_to
      obj_price_from: $obj_price_from
      obj_price_to: $obj_price_to
      obj_type: $obj_type
      obj_patterns: $obj_patterns
      obj_time: $obj_time
      obj_transfer: $obj_transfer
      obj_land_data: $obj_land_data
      obj_build_data: $obj_build_data
      obj_bulletin_data: $obj_bulletin_data
      orderBy: $orderBy
      bid: $bid
      source: $source
      desc: $desc
      frontSite: $frontSite
      errorLog: $errorLog
      popular: $popular
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        obj_no
        obj_court
        obj_str
        obj_share
        obj_caseno
        obj_another
        obj_time
        obj_date_ymd
        obj_date_hi
        obj_city
        obj_area
        obj_section
        obj_section_s
        obj_landno
        obj_address
        obj_margin
        obj_price
        obj_price_set
        obj_debtor
        obj_build_floor
        obj_land_floor
        obj_add_floor
        obj_s_floor
        obj_c_floor
        obj_total_floor
        obj_bulletin_data
        obj_land_data
        obj_build_data
        obj_transfer
        obj_type
        obj_stop
        obj_stop_link
        obj_check_num
        obj_patterns
        errorLog
        images {
          id
          imageUrl
        }
        mark
      }
    }
  }
`;

const GET_TRACKINGFORECLOSURES = gql`
  query trackingForeclosures(
    $userId: Int
    $orderBy: String
    $desc: Boolean
    $pageSize: Int
    $page: Int
  ) {
    trackingForeclosures(
      userId: $userId
      orderBy: $orderBy
      desc: $desc
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        obj_no
        obj_court
        obj_str
        obj_share
        obj_caseno
        obj_another
        obj_time
        obj_date_ymd
        obj_date_hi
        obj_city
        obj_area
        obj_section
        obj_section_s
        obj_landno
        obj_address
        obj_margin
        obj_price
        obj_price_set
        obj_debtor
        obj_build_floor
        obj_land_floor
        obj_add_floor
        obj_s_floor
        obj_c_floor
        obj_total_floor
        obj_bulletin_data
        obj_land_data
        obj_build_data
        obj_transfer
        obj_type
        obj_patterns
        obj_stop
        obj_stop_link
        errorLog
        images {
          id
          imageUrl
        }
        newest
        mark
      }
    }
  }
`;

const SAVE_TRACKINGFORECLOSURE = gql`
  mutation saveTrackingForeclosure($userId: Int!, $foreclosureIds: [Int]!) {
    saveTrackingForeclosure(userId: $userId, foreclosureIds: $foreclosureIds)
  }
`;

const DELETE_TRACKINGFORECLOSURE = gql`
  mutation deleteTrackingForeclosure($ids: [Int]!) {
    deleteTrackingForeclosure(ids: $ids)
  }
`;
const ADD_EXCLUSIVEPROPERTY = gql`
  mutation addExclusiveProperty($franchiseStoreId: Int!, $ids: [Int]!) {
    addExclusiveProperty(franchiseStoreId: $franchiseStoreId, ids: $ids)
  }
`;
const CHANGE_TRACKINGFORECLOSURENEWEST = gql`
  mutation changeTrackingForeclosureNewest($id: Int!) {
    changeTrackingForeclosureNewest(id: $id)
  }
`;

const CHANGE_TRACKINGFORECLOSUREMARK = gql`
  mutation changeTrackingForeclosureMark(
    $foreclosureIds: [Int]
    $markType: MarkType
  ) {
    changeTrackingForeclosureMark(
      foreclosureIds: $foreclosureIds
      markType: $markType
    )
  }
`;

const PIN_TRACKINGFORECLOSURE = gql`
  mutation pinTrackingForeclosure($foreclosureIds: [Int]) {
    pinTrackingForeclosure(foreclosureIds: $foreclosureIds)
  }
`;

const SAVE_MARKFORECLOSURE = gql`
  mutation saveMarkForeclosure($foreclosureIds: [Int], $markType: MarkType) {
    saveMarkForeclosure(foreclosureIds: $foreclosureIds, markType: $markType)
  }
`;

const DELETE_MARKFORECLOSURE = gql`
  mutation deleteMarkForeclosure($foreclosureIds: [Int]) {
    deleteMarkForeclosure(foreclosureIds: $foreclosureIds)
  }
`;

export default function SaleObjTable({ id }) {
  const history = useHistory();
  const isTable = useMediaQuery("(min-width:500px)");
  const Alert = useAlert();
  const [updateData, setUpdateData] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [ids, setIds] = useState([]);
  const [printData, setPrintData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const orderArray = [
    { label: "投標日", value: "DATE" },
    { label: "縣市", value: "OBJ_CITY" },
    { label: "拍次", value: "OBJ_TIME" },
  ];
  const pageArray = [
    {
      label: "10筆",
      value: 10,
    },
    {
      label: "20筆",
      value: 20,
    },
    {
      label: "30筆",
      value: 30,
    },
    {
      label: "40筆",
      value: 40,
    },
    {
      label: "50筆",
      value: 50,
    },
    {
      label: "100筆",
      value: 100,
    },
    {
      label: "200筆",
      value: 200,
    },
  ];
  const { courtArray } = propertyDataArray();
  const [newData, setNewData] = useState({
    orderObject: { label: "投標日", value: "DATE" },
    courtObject: {
      label: "臺灣臺中地方法院",
      value: "TCD",
    },
    currentData: [],
    logData: {},
    images: [],
    no: null,
    debtor: "",
    logOpen: false,
    page: 1,
    pageCount: 1,
    mapData: {},
    infoOpen: false,
    info: null,
    pageSize: {
      label: `${history.location.state?.newData.pageSize.value}筆`,
      value: Number(history.location.state?.newData.pageSize.value),
    },
  });
  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  const nameLength = (name) => {
    if (name.length > 3) {
      return name.substr(0, 3);
    } else {
      return name;
    }
  };
  function getAddress(city, area, address) {
    let index;
    let newAddress;
    if (address.includes("路")) {
      index = address.indexOf("路");
    } else if (address.includes("街")) {
      index = address.indexOf("街");
    } else if (address.includes("村")) {
      index = address.indexOf("村");
    }
    newAddress = address.substring(0, index + 1);
    if (
      newAddress.includes(city) ||
      newAddress.includes(area) ||
      newAddress.includes(`台${city.substring(1, 3)}`)
    ) {
      newAddress = newAddress.replace(`台${city.substring(1, 3)}`, "");
      newAddress = newAddress.replace(city, "");
      newAddress = newAddress.replace(area, "");
    }

    return city + area + newAddress;
  }
  const useStyles = makeStyles((theme) => ({
    DocumentContainerCenter: {
      display: "flex",
      alignItems: "center",
    },
    socialBtns: {
      display: "flex",
      alingItems: "center",
    },
    svgIcons: {
      width: "25px",
      height: "25px",
    },
  }));
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mapAnchorEl, setMapAnchorEl] = useState(null);

  const handleMapPopoverOpen = (
    event,
    obj_type,
    obj_city,
    obj_area,
    obj_address,
    obj_section,
    obj_section_s,
    obj_landno
  ) => {
    setMapAnchorEl(event.currentTarget);
    changeData(
      "mapData",
      {
        obj_type,
        obj_city,
        obj_area,
        obj_address,
        obj_section,
        obj_section_s,
        obj_landno,
      },
      true
    );
  };

  const handleMapPopoverClose = () => {
    setMapAnchorEl(null);
    changeData("mapData", {}, true);
  };

  const mapOpen = Boolean(mapAnchorEl);

  const handlePopoverOpen = (event, no, debtor) => {
    setAnchorEl(event.currentTarget);
    changeData("debtor", debtor);
    changeData("no", no, true);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    changeData("currentData", []);
    changeData("no", undefined, true);
  };

  const open = Boolean(anchorEl);

  const [getForeclosures, { data, loading }] = useLazyQuery(GET_FORECLOSURES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });

  const [
    getTrackingForeclosures,
    { data: trackingForeclosureData, loading: trackingForeclosureLoading },
  ] = useLazyQuery(GET_TRACKINGFORECLOSURES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onError(error) {
      Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
    },
  });

  const [
    deleteTrackingForeclosure,
    { loading: deleteTrackingForeclosureLoading },
  ] = useMutation(DELETE_TRACKINGFORECLOSURE, {
    onCompleted({ deleteTrackingForeclosure }) {
      if (deleteTrackingForeclosure) {
        setIds([]);
        setPrintData([]);
        getTrackingForeclosures({
          variables: {
            userId: Number(localStorage.getItem("@fullhouseUserId")),
            orderBy: newData.orderObject.value,
            desc: true,
            pageSize: 10,
            page: newData.page,
          },
        });
        return Alert.notice("刪除成功！");
      }
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });

  const [saveTrackingForeclosure, { loading: saveTrackingForeclosureLoading }] =
    useMutation(SAVE_TRACKINGFORECLOSURE, {
      onCompleted({ saveTrackingForeclosure }) {
        if (saveTrackingForeclosure) {
          setIds([]);
          setPrintData([]);
          return Alert.notice("儲存成功！");
        }
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    });

  const [addExclusiveProperty, { loading: addExclusivePropertyLoading }] =
    useMutation(ADD_EXCLUSIVEPROPERTY, {
      onCompleted({ addExclusiveProperty }) {
        if (addExclusiveProperty) {
          setIds([]);
          setPrintData([]);
          return Alert.notice("儲存成功！");
        }
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    });

  const [
    changeTrackingForeclosureNewest,
    { loading: changeTrackingForeclosureNewestLoading },
  ] = useMutation(CHANGE_TRACKINGFORECLOSURENEWEST);

  const [
    changeTrackingForeclosureMark,
    { loading: changeTrackingForeclosureMarkLoading },
  ] = useMutation(CHANGE_TRACKINGFORECLOSUREMARK, {
    onCompleted({ changeTrackingForeclosureMark }) {
      if (changeTrackingForeclosureMark) setUpdateData(!updateData);
    },
  });

  const [pinTrackingForeclosure, { loading: pinTrackingForeclosureLoading }] =
    useMutation(PIN_TRACKINGFORECLOSURE, {
      onCompleted({ pinTrackingForeclosure }) {
        if (pinTrackingForeclosure) setUpdateData(!updateData);
      },
    });

  const [saveMarkForeclosure, { loading: saveMarkForeclosureLoading }] =
    useMutation(SAVE_MARKFORECLOSURE, {
      onCompleted({ saveMarkForeclosure }) {
        if (saveMarkForeclosure) setUpdateData(!updateData);
      },
    });

  const [deleteMarkForeclosure, { loading: deleteMarkForeclosureLoading }] =
    useMutation(DELETE_MARKFORECLOSURE, {
      onCompleted({ deleteMarkForeclosure }) {
        if (deleteMarkForeclosure) setUpdateData(!updateData);
      },
    });

  useEffect(() => {
    if (
      history.location.state ||
      localStorage.getItem("@exclusiveWebCondition")
    ) {
      const condition =
        history.location.state?.newData ??
        JSON.parse(localStorage.getItem("@exclusiveWebCondition"))?.newData;
      const division =
        history.location.state?.division ??
        JSON.parse(localStorage.getItem("@exclusiveWebCondition"))?.division;
      const subdivisions =
        history.location.state?.subdivisions ??
        JSON.parse(localStorage.getItem("@exclusiveWebCondition"))
          ?.subdivisions;
      let typeArray = [];
      let auctions = [];
      let sourceArray = [];
      let cityArray = [];
      let areaArray = [];
      if (condition.typeArray) {
        condition.typeArray.map((item) => {
          typeArray.push(item.label);
        });
      }
      if (condition.auArray) {
        condition.auArray.map((item) => {
          auctions.push(item.value);
        });
      }
      if (condition.sourceData) {
        condition.sourceData.map((item) => {
          sourceArray.push(item.value);
        });
      }
      if (condition.areaData) {
        condition.areaData.forEach((item) => {
          item.forEach((item2) => {
            cityArray.push(item2.label);
            item2.subdivisions?.forEach((item3) => areaArray.push(item3.label));
          });
        });
      }

      getForeclosures({
        variables: {
          obj_caseno: condition.signal ? condition.signal : undefined,
          obj_city: condition.areaData
            ? cityArray
            : division
            ? [division]
            : undefined,
          obj_area: condition.areaData
            ? areaArray
            : subdivisions
            ? [subdivisions]
            : undefined,
          obj_address: condition.address ? condition.address : undefined,
          searchTerm: condition.searchTerm ? condition.searchTerm : undefined,
          obj_date_ymd_from: condition.dateStart
            ? new Date(condition.dateStart)
            : undefined,
          obj_date_ymd_to: condition.dateEnd
            ? new Date(condition.dateEnd)
            : undefined,
          obj_creat_date_from: condition.addedtoday
            ? new Date()
            : condition.recentlyAddedStart
            ? new Date(condition.recentlyAddedStart)
            : undefined,
          obj_creat_date_to: condition.addedtoday
            ? undefined
            : condition.recentlyAddedEnd
            ? new Date(condition.recentlyAddedEnd)
            : undefined,
          obj_build_floor_from: condition.jianpingStart
            ? Number(condition.jianpingStart)
            : undefined,
          obj_build_floor_to: condition.jianpingEnd
            ? Number(condition.jianpingEnd)
            : undefined,
          obj_price_from: condition.basePriceStart
            ? Number(condition.basePriceStart)
            : undefined,
          obj_price_to: condition.basePriceEnd
            ? Number(condition.basePriceEnd)
            : undefined,
          obj_type: (() => {
            switch (condition.typeLand.length) {
              case 1:
                if (condition.typeLand.indexOf("土地") !== -1) return "L";
                else if (condition.typeLand.indexOf("建物") !== -1) return "H";
              case 2:
                return undefined;
              default:
                break;
            }
          })(),
          obj_patterns: typeArray.length > 0 ? typeArray : undefined,
          obj_time:
            condition.respondBuy === "during"
              ? ["0", "during"]
              : condition.respondBuy === "regular"
              ? ["0"]
              : auctions.length > 0
              ? auctions
              : undefined,
          obj_transfer:
            condition.pointHand === "null" ? undefined : condition.pointHand,
          obj_land_data:
            condition.landRights === "null" ? undefined : condition.landRights,
          obj_build_data:
            condition.buildRights === "null"
              ? undefined
              : condition.buildRights,
          obj_bulletin_data:
            condition.roadCondition === "null"
              ? undefined
              : condition.roadCondition,
          orderBy: condition.latest ? condition.latest.value : undefined,
          desc: true,
          source: sourceArray.length > 0 ? sourceArray : undefined,
          frontSite: false,
          bid: condition.winthebid,
          errorLog: errorMessage,
          popular: false,
          pageSize: newData.pageSize.value,
          page: newData.page,
        },
      });
    } else {
      if (!!localStorage.getItem("@fullhouseEventData")) {
        let newNo = [];
        JSON.parse(localStorage.getItem("@fullhouseEventData")).forEach(
          (item) => {
            newNo.push(item.obj_no);
          }
        );
        getForeclosures({
          variables: {
            obj_no: newNo,
            desc: true,
            pageSize: 10,
            page: newData.page,
          },
        });
        localStorage.removeItem("@fullhouseEventData");
      } else if (!window.location.pathname.includes("new-favorite")) {
        getForeclosures({
          variables: {
            obj_court: newData.courtObject.value,
            obj_date_ymd_from: moment(new Date())
              .subtract(3, "months")
              .toDate(),
            obj_date_ymd_to: moment(new Date()).toDate(),
            popular: true,
          },
        });
      }
    }
    getTrackingForeclosures({
      variables: {
        userId: Number(localStorage.getItem("@fullhouseUserId")),
        orderBy: newData.orderObject.value,
        desc: true,
        pageSize: 10,
        page: newData.page,
      },
    });
    setIds([]);
    setPrintData([]);
  }, [
    history.location.state,
    newData.pageSize,
    newData.page,
    errorMessage,
    newData.orderObject,
    newData.courtObject,
    updateData,
  ]);

  useEffect(() => {
    if (history.location.state) setTableData(data?.foreclosures?.contents);
    else if (window.location.pathname.includes("new-favorite"))
      setTableData(trackingForeclosureData?.trackingForeclosures?.contents);
    else setTableData(data?.foreclosures?.contents);
  }, [data, trackingForeclosureData]);

  function getPatterns(obj_type, obj_patterns) {
    switch (obj_type) {
      case "L":
        return obj_patterns !== "" ? obj_patterns : "土地";
      case "H":
        return obj_patterns !== "" ? obj_patterns : "建物";
      default:
        return "";
    }
  }

  function getCaseName(obj_str, obj_share, obj_caseno, obj_another) {
    const share = Array.from(obj_share);
    const condition = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    let sourcefnp = false;
    if (share.indexOf("台") > -1 && share.indexOf("金") > -1) {
      sourcefnp = true;
    } else {
      share.forEach((item) => {
        condition.map((item2) => {
          if (item.indexOf(item2) > -1) sourcefnp = true;
        });
      });
    }

    return sourcefnp
      ? obj_str +
          "批號" +
          obj_caseno +
          (!!obj_another &&
          obj_another.indexOf("(") === -1 &&
          obj_another.indexOf("-") === -1
            ? "(" + obj_another + ")"
            : obj_another) +
          "\n"
      : obj_str +
          obj_share +
          obj_caseno +
          (!!obj_another &&
          obj_another.indexOf("(") === -1 &&
          obj_another.indexOf("-") === -1
            ? "(" + obj_another + ")"
            : obj_another) +
          "\n";
  }
  const identity = localStorage.getItem("@fullhouseIdentity") === "STAFF";
  if (loading || trackingForeclosureLoading || typeof identity !== "boolean") {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <>
        <LoadingModal
          loading={
            saveTrackingForeclosureLoading ||
            deleteTrackingForeclosureLoading ||
            addExclusivePropertyLoading ||
            changeTrackingForeclosureNewestLoading ||
            changeTrackingForeclosureMarkLoading ||
            pinTrackingForeclosureLoading ||
            saveMarkForeclosureLoading ||
            deleteMarkForeclosureLoading
          }
        />
        <CardContent
          style={{
            position: "sticky",
            top: 0,
            zIndex: 999,
            backgroundColor: "white",
            borderRadius: "5px",
          }}
        >
          {history.location.state ? (
            <Grid container spacing={2} justifyContent="space-between">
              <Grid item sm={3}>
                <Grid container spacing={1}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    classes={{ root: classes.DocumentContainerCenter }}
                  >
                    <Checkbox
                      color="primary"
                      checked={errorMessage}
                      onChange={() => setErrorMessage(!errorMessage)}
                    />
                    <Typography color="primary" style={{ fontSize: 15 }}>
                      搜尋錯誤物件
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography color="primary" style={{ fontSize: 15 }}>
                      每頁顯示
                    </Typography>
                    <Select
                      items={pageArray}
                      value={newData.pageSize}
                      onChange={(e, value) => {
                        if (value) {
                          changeData("pageSize", value, true);
                        } else {
                          changeData({});
                        }
                      }}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container spacing={1}>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={ids.length === 0}
                      onClick={() => {
                        saveTrackingForeclosure({
                          variables: {
                            userId: Number(
                              localStorage.getItem("@fullhouseUserId")
                            ),
                            foreclosureIds: ids,
                          },
                        });
                      }}
                    >
                      批次加入列管追蹤
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={ids.length === 0}
                      onClick={() => {
                        localStorage.setItem(
                          "@printData",
                          JSON.stringify(printData)
                        );
                        window.open(`/print`, "_blank", "noopener");
                      }}
                    >
                      列印
                    </Button>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item>
                    <Grid container spacing={1}>
                      <Grid item>
                        <IconButton
                          disabled={ids.length === 0}
                          onClick={() => {
                            saveMarkForeclosure({
                              variables: {
                                foreclosureIds: ids,
                                markType: "RED",
                              },
                            });
                          }}
                        >
                          <FavoriteIcon style={{ color: "red" }} />
                        </IconButton>
                      </Grid>
                      <Grid item>
                        <IconButton
                          disabled={ids.length === 0}
                          onClick={() => {
                            saveMarkForeclosure({
                              variables: {
                                foreclosureIds: ids,
                                markType: "BLUE",
                              },
                            });
                          }}
                        >
                          <StarIcon style={{ color: "blue" }} />
                        </IconButton>
                      </Grid>
                      <Grid item>
                        <IconButton
                          disabled={ids.length === 0}
                          onClick={() => {
                            deleteMarkForeclosure({
                              variables: {
                                foreclosureIds: ids,
                              },
                            });
                          }}
                        >
                          <ClearIcon style={{ color: "black" }} />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ) : window.location.pathname.includes("exclusive-web") ? (
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={ids.length === 0}
                  onClick={() => {
                    addExclusiveProperty({
                      variables: { franchiseStoreId: id, ids },
                    });
                  }}
                >
                  加入專屬網站
                </Button>
              </Grid>
            </Grid>
          ) : window.location.pathname.includes("new-favorite") ? (
            <Grid container justifyContent="space-between">
              <Grid item sm={2}>
                <Typography color="primary">排序</Typography>
                <Select
                  items={orderArray}
                  value={newData.orderObject}
                  onChange={(e, v) => {
                    if (v) changeData("orderObject", v, true);
                    else changeData("orderObject", {}, true);
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item>
                <Grid container spacing={1}>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={ids.length === 0}
                      onClick={() => {
                        deleteTrackingForeclosure({
                          variables: { ids },
                        });
                      }}
                    >
                      移除列管追蹤
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={ids.length === 0}
                      onClick={() => {
                        pinTrackingForeclosure({
                          variables: { foreclosureIds: ids },
                        });
                      }}
                    >
                      置頂
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={ids.length === 0}
                      onClick={() => {
                        localStorage.setItem(
                          "@printData",
                          JSON.stringify(printData)
                        );
                        window.open(`/print`, "_blank", "noopener");
                      }}
                    >
                      列印
                    </Button>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item>
                    <Grid container spacing={1}>
                      <Grid item>
                        <IconButton
                          disabled={ids.length === 0}
                          onClick={() => {
                            changeTrackingForeclosureMark({
                              variables: {
                                foreclosureIds: ids,
                                markType: "RED",
                              },
                            });
                          }}
                        >
                          <FavoriteIcon style={{ color: "red" }} />
                        </IconButton>
                      </Grid>
                      <Grid item>
                        <IconButton
                          disabled={ids.length === 0}
                          onClick={() => {
                            changeTrackingForeclosureMark({
                              variables: {
                                foreclosureIds: ids,
                                markType: "BLUE",
                              },
                            });
                          }}
                        >
                          <StarIcon style={{ color: "blue" }} />
                        </IconButton>
                      </Grid>
                      <Grid item>
                        <IconButton
                          disabled={ids.length === 0}
                          onClick={() => {
                            changeTrackingForeclosureMark({
                              variables: {
                                foreclosureIds: ids,
                                markType: null,
                              },
                            });
                          }}
                        >
                          <ClearIcon style={{ color: "black" }} />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <Grid
              container
              justifyContent={
                localStorage.getItem("fullhouseEventData")
                  ? "space-between"
                  : "flex-end"
              }
            >
              {localStorage.getItem("fullhouseEventData") && (
                <Grid item sm={2}>
                  <Typography color="primary">選擇法院</Typography>
                  <Select
                    items={courtArray}
                    value={newData.courtObject}
                    onChange={(e, v) => {
                      if (v) changeData("courtObject", v, true);
                      else changeData("courtObject", {}, true);
                    }}
                    fullWidth
                  />
                </Grid>
              )}
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={ids.length === 0}
                  onClick={() => {
                    saveTrackingForeclosure({
                      variables: {
                        userId: Number(
                          localStorage.getItem("@fullhouseUserId")
                        ),
                        foreclosureIds: ids,
                      },
                    });
                  }}
                >
                  批次加入列管追蹤
                </Button>
              </Grid>
            </Grid>
          )}
        </CardContent>
        {isTable ? (
          <Box id="printable">
            <CardContent style={{ padding: 0 }}>
              <Table
                stickyHeaderTop
                height={500}
                data={tableData ? tableData : []}
                tableWidth={3}
                columnWidths={[
                  10, 70, 180, 200, 150, 80, 70, 105, 100, 70, 70, 80,
                ]}
                header={[
                  <Checkbox
                    checked={Boolean(ids.length === tableData?.length)}
                    onClick={(event) => {
                      event.stopPropagation();
                      let allData = [];
                      let allObjNo = [];
                      if (
                        ids.length !== 0 &&
                        ids.length !== tableData?.length
                      ) {
                        setIds([]);
                        setPrintData([]);
                        tableData?.forEach((item) => {
                          allObjNo.push(Number(item.obj_no));
                          allData.push(item);
                        });
                        setPrintData(allData);
                        setIds(allObjNo);
                      } else if (ids.length === tableData?.length) {
                        setIds([]);
                        setPrintData([]);
                      } else if (ids.length === 0) {
                        tableData?.forEach((item) => {
                          allObjNo.push(Number(item.obj_no));
                          allData.push(item);
                        });
                        setIds(allObjNo);
                        setPrintData(allData);
                      }
                    }}
                  />,
                  "編號",
                  "案號\n債務人",
                  "大樓案名\n門牌地址",
                  "日期\n時間",
                  "類別\n狀況",
                  "建坪\n地坪",
                  "建坪／萬\n地坪／萬",
                  "拍賣底價\n保證金",
                  "拍次\n點交",
                  `${
                    !history.location.state &&
                    !window.location.pathname.includes("new-favorite")
                      ? "點擊次數"
                      : "錯誤物件"
                  }`,
                  "編輯\n錯誤回報",
                ]}
                columns={[
                  (item) => (
                    <>
                      <Checkbox
                        checked={Boolean(
                          ids.find((item2) => item2 === item.obj_no)
                        )}
                        onClick={(event) => {
                          event.stopPropagation();
                          const hasId = ids.find(
                            (item2) => item2 === item.obj_no
                          );
                          if (hasId) {
                            setIds((e) => e.filter((i) => i !== item.obj_no));
                            setPrintData((e) =>
                              e.filter((i) => i.obj_no !== item.obj_no)
                            );
                          } else {
                            setIds((e) => [...e, Number(item.obj_no)]);
                            setPrintData((e) => [...e, item]);
                          }
                        }}
                      />
                      {!window.location.pathname.includes("new-favorite") &&
                        trackingForeclosureData?.trackingForeclosures?.contents.find(
                          (item2) => item2.obj_no === item.obj_no
                        ) && (
                          <Text type="subtitle2" color="red">
                            已列管
                          </Text>
                        )}
                    </>
                  ),
                  (_, index) => (
                    <Grid>
                      <Text>{index + 1}</Text>
                    </Grid>
                  ),
                  (item) => (
                    <>
                      <Grid container justifyContent="center">
                        {item.obj_transfer === "1" && (
                          <Grid item>
                            <ThumbUpIcon />
                          </Grid>
                        )}

                        {item.images.length > 0 && (
                          <Grid item>
                            <CameraAltIcon />
                          </Grid>
                        )}
                      </Grid>
                      <Text
                        color="#22b169"
                        aria-describedby={
                          mapOpen ? "mouse-over-mapPopover" : undefined
                        }
                        onMouseEnter={(event) => {
                          handleMapPopoverOpen(
                            event,
                            item.obj_type,
                            item.obj_city,
                            item.obj_area,
                            item.obj_address,
                            item.obj_section,
                            item.obj_section_s,
                            item.obj_landno
                          );
                        }}
                      >
                        {getCaseName(
                          item.obj_str,
                          item.obj_share,
                          item.obj_caseno,
                          item.obj_another
                        )}
                      </Text>
                      <Text
                        aria-describedby={
                          open ? "mouse-over-popover" : undefined
                        }
                        onMouseEnter={(event) => {
                          handlePopoverOpen(
                            event,
                            item.obj_no,
                            item.obj_debtor
                          );
                        }}
                      >
                        {item.obj_debtor.length > 10
                          ? item.obj_debtor.substr(0, 8) + ".."
                          : item.obj_debtor}
                      </Text>
                    </>
                  ),
                  (item) => (
                    <Grid container justifyContent="center">
                      <Grid item>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            localStorage.setItem(
                              "@fullhouseMapData",
                              JSON.stringify({
                                obj_type: item.obj_type,
                                obj_city: item.obj_city,
                                obj_area: item.obj_area,
                                obj_address: item.obj_address,
                                obj_section: item.obj_section,
                                obj_section_s: item.obj_section_s,
                                obj_landno: item.obj_landno,
                              })
                            );
                            window.open(
                              `/console/map`,
                              "_blank",
                              "noopener"
                              // "height=500,width=300"
                            );
                          }}
                        >
                          <MapIcon />
                        </IconButton>

                        <LineShareButton
                          url={
                            window.location.origin +
                            "/" +
                            "simple-info" +
                            "/" +
                            item.obj_no +
                            "?mobile=" +
                            localStorage.getItem("@fullhouseUserMobile")
                          }
                        >
                          <IconButton size="small">
                            <ShareIcon />
                          </IconButton>
                        </LineShareButton>
                        {item.newest && (
                          <IconButton size="small">
                            <FiberNewIcon />
                          </IconButton>
                        )}
                      </Grid>
                      <Grid item>
                        <Text color="#22b169">
                          {item.obj_city + item.obj_area + "\n"}
                        </Text>
                        {item.obj_type === "H" ? (
                          <Text>
                            {item.obj_city + item.obj_area + item.obj_address}
                          </Text>
                        ) : (
                          <Text>
                            {item.obj_city +
                              item.obj_area +
                              item.obj_section +
                              "段" +
                              item.obj_section_s +
                              (item.obj_section_s ? "小段" : "") +
                              item.obj_landno +
                              (item.obj_landno ? "地號" : "")}
                          </Text>
                        )}
                      </Grid>
                      <Grid item>
                        {history.location.state?.newData.photo &&
                        item.images ? (
                          <CarouselImages data={item.images} />
                        ) : null}
                        {history.location.state?.newData.mapMode ? (
                          <Map
                            width={"200px"}
                            height={"200px"}
                            direction={"column"}
                            sm={12}
                            mapData={{
                              obj_type: item.obj_type,
                              obj_city: item.obj_city,
                              obj_area: item.obj_area,
                              obj_address: item.obj_address,
                              obj_section: item.obj_section,
                              obj_section_s: item.obj_section_s,
                              obj_landno: item.obj_landno,
                            }}
                          />
                        ) : null}
                      </Grid>
                    </Grid>
                  ),
                  (item) => (
                    <>
                      <Text color="#22b169">
                        {moment(item.obj_date_ymd).format("YYYY-MM-DD") + "\n"}
                      </Text>
                      {history.location.state?.newData.respondBuy ===
                        "during" && <Text>{"到\n"}</Text>}
                      <Text>
                        {history.location.state?.newData.respondBuy === "during"
                          ? moment(item.obj_date_ymd)
                              .add(3, "months")
                              .format("YYYY-MM-DD")
                          : moment(item.obj_date_hi).format("HH:mm")}
                      </Text>
                      {item.obj_price_set !== 0 && (
                        <>
                          <Grid container justifyContent="center">
                            <GavelIcon fontSize="small" />
                          </Grid>
                          <Text
                            style={{ backgroundColor: "#ff9800" }}
                          >{`\n拍定價:${(item.obj_price_set / 10000).toFixed(
                            2
                          )}萬\n`}</Text>
                          <Text
                            style={{ backgroundColor: "#ff9800" }}
                          >{`每坪價:${
                            item.obj_type === "H"
                              ? (item.obj_price / item.obj_total_floor).toFixed(
                                  2
                                ) + "萬"
                              : (item.obj_price / item.obj_land_floor).toFixed(
                                  2
                                ) + "萬"
                          }`}</Text>
                        </>
                      )}
                    </>
                  ),
                  (item) => (
                    <>
                      <Text>
                        {getPatterns(item.obj_type, item.obj_patterns) + "\n"}
                      </Text>
                      {item.obj_stop !== "" && (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(
                              `${item.obj_stop_link}`,
                              "_blank",
                              "noopener"
                            );
                          }}
                        >
                          停拍公告
                        </Button>
                      )}
                    </>
                  ),
                  (item) => (
                    <>
                      <Text color="#22b169">{item.obj_total_floor + "\n"}</Text>
                      <Text>{item.obj_land_floor}</Text>
                    </>
                  ),
                  (item) => (
                    <>
                      <Text color="#22b169">
                        {item.obj_total_floor === 0
                          ? 0 + "\n"
                          : (item.obj_price / item.obj_total_floor).toFixed(2) +
                            "萬" +
                            "\n"}
                      </Text>
                      <Text>
                        {item.obj_land_floor === 0
                          ? 0
                          : (item.obj_price / item.obj_land_floor).toFixed(2) +
                            "萬"}
                      </Text>
                    </>
                  ),
                  (item) => (
                    <>
                      <Text color="#22b169">
                        {item.obj_price + "萬" + "\n"}
                      </Text>
                      <Text>{(item.obj_margin / 10000).toFixed(2) + "萬"}</Text>
                    </>
                  ),
                  (item) => (
                    <>
                      <Text color="#22b169">
                        {`${item.obj_time === "0" ? "應買" : item.obj_time}` +
                          "\n"}
                      </Text>
                      <Text>
                        {(() => {
                          switch (item.obj_transfer) {
                            case "0":
                              return "不點交";
                            case "1":
                              return "點交";
                            case "2":
                              return "依公文判斷";
                            default:
                              break;
                          }
                        })()}
                      </Text>
                    </>
                  ),
                  (item) => {
                    if (
                      !history.location.state &&
                      !window.location.pathname.includes("new-favorite")
                    ) {
                      return <Text>{item.obj_check_num}</Text>;
                    } else {
                      return <Text>{item.errorLog}</Text>;
                    }
                  },
                  (item) => (
                    <Grid container spacing={1}>
                      {identity && (
                        <Grid item sm={12} xs={12}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(
                                `/console/sale-obj-search-results-edit/${item.obj_no}`,
                                "_blank",
                                "noopener"
                              );
                            }}
                            style={{ color: "#212121" }}
                          >
                            編輯
                          </Button>
                        </Grid>
                      )}
                      <Grid item sm={12} xs={12}>
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "#f44336",
                            color: "#212121",
                            whiteSpace: "nowrap",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            changeData("logData", {
                              obj:
                                courtArray.find(
                                  (item2) => item2.value === item.obj_court
                                )?.label +
                                "\u2002" +
                                item.obj_str +
                                item.obj_share +
                                item.obj_caseno +
                                item.obj_another,
                              address:
                                item.obj_type === "H"
                                  ? item.obj_city +
                                    item.obj_area +
                                    item.obj_address
                                  : item.obj_city +
                                    item.obj_area +
                                    item.obj_section +
                                    "段" +
                                    item.obj_section_s +
                                    (item.obj_section_s ? "小段" : "") +
                                    item.obj_landno +
                                    (item.obj_landno ? "地號" : ""),
                            });
                            changeData("logOpen", true, true);
                          }}
                        >
                          錯誤回報
                        </Button>
                      </Grid>
                    </Grid>
                  ),
                ]}
                onPress={(item) => {
                  if (item.newest) {
                    changeTrackingForeclosureNewest({
                      variables: { id: item.obj_no },
                    });
                  }
                  window.open(
                    `/console/sale-obj-search-results/${item.obj_no}`,
                    "_blank",
                    "noopener"
                  );
                }}
              />

              <ErrorLogReport
                data={{ open: newData.logOpen, logData: newData.logData }}
                onClose={() => {
                  changeData("logOpen", false, true);
                }}
              />
              <Map
                mapData={newData.mapData}
                open={mapOpen}
                popper
                anchorEl={mapAnchorEl}
                onClose={handleMapPopoverClose}
              />
              <CurrentPopper
                data={{
                  open,
                  debtor: newData.debtor,
                  no: newData.no,
                  anchorEl,
                }}
                onClose={handlePopoverClose}
              />
            </CardContent>
          </Box>
        ) : (
          (history.location.state
            ? data?.foreclosures?.contents
            : window.location.pathname.includes("new-favorite")
            ? trackingForeclosureData?.trackingForeclosures?.contents
            : data?.foreclosures?.contents
          )?.map((item) => {
            return (
              <>
                <Grid
                  container
                  spacing={1}
                  classes={{ root: classes.DocumentContainerCenter }}
                >
                  <Typography color="primary">
                    {getCaseName(
                      item.obj_str,
                      item.obj_share,
                      item.obj_caseno,
                      item.obj_another
                    )}
                  </Typography>
                  <Typography color="primary">{"\u2002|\u2002"}</Typography>
                  <Typography color="primary">
                    {item.obj_type === "L"
                      ? `${item.obj_city + item.obj_area + item.obj_section}段${
                          item.obj_section_s ? item.obj_section_s + "小段" : ""
                        }`
                      : getAddress(
                          item.obj_city,
                          item.obj_area,
                          item.obj_address
                        )}
                  </Typography>
                  {item.errorLog && (
                    <IconButton size="small">
                      <ErrorOutlineIcon />
                    </IconButton>
                  )}
                </Grid>
                <CardActionArea
                  onClick={() => {
                    history.push(
                      `/console/sale-obj-search-results/${item.obj_no}`,
                      { id: item.obj_no }
                    );
                  }}
                >
                  <Grid container>
                    <Typography>{nameLength(item.obj_debtor)}</Typography>
                    <Typography color="primary">{"\u2002|\u2002"}</Typography>
                    <Typography style={{ color: "#3d5afe" }}>
                      {/* {addressLength(item.obj_area, item.obj_address)} */}
                      {item.obj_area}
                    </Typography>
                  </Grid>
                  {/* TODO  */}
                  <Grid container>
                    <Typography>
                      {getPatterns(item.obj_type, item.obj_patterns)}
                    </Typography>
                    <Typography color="primary">{"\u2002|\u2002"}</Typography>
                    <Typography>{item.obj_time + "拍"}</Typography>
                    <Typography color="primary">{"\u2002|\u2002"}</Typography>
                    <Typography>
                      {(() => {
                        switch (item.obj_transfer) {
                          case "0":
                            return "不點交";
                          case "1":
                            return "點交";
                          case "2":
                            return item.obj_remark;
                          default:
                            break;
                        }
                      })()}
                    </Typography>
                    <Typography color="primary">{"\u2002|\u2002"}</Typography>
                    <Typography>
                      {moment(item.obj_date_ymd).format("MM-DD")}
                    </Typography>
                    <Typography color="primary">-</Typography>
                    <Typography>
                      {moment(item.obj_date_hi).format("HH:mm")}
                    </Typography>
                  </Grid>
                  <Grid container>
                    <Typography style={{ color: "#ff1744" }}>
                      {"地坪:" + item.obj_land_floor}
                    </Typography>
                    {/* <Typography>2100.50萬/坪</Typography> */}
                    <Typography color="primary">
                      {"\u2002\u2002\u2002"}
                    </Typography>
                    <Typography style={{ color: "#ff1744" }}>
                      {"建坪:" + item.obj_build_floor}
                    </Typography>
                    {/* <Typography>56.10萬/坪</Typography> */}
                  </Grid>
                  <Grid container>
                    <Typography style={{ color: "#ff1744" }}>
                      {"底價"}
                    </Typography>
                    <Typography>{item.obj_price + "萬"}</Typography>
                    <Typography color="primary">
                      {"\u2002\u2002\u2002\u2002\u2002\u2002"}
                    </Typography>
                    <Typography style={{ color: "#ff1744" }}>保證金</Typography>
                    <Typography>
                      {(item.obj_margin / 10000).toFixed(2) + "萬"}
                    </Typography>
                  </Grid>
                </CardActionArea>
                <IconButton
                  size="small"
                  onClick={() => {
                    changeData("infoOpen", true);
                    changeData("info", { type: "simpleInfo", item }, true);
                  }}
                >
                  <MenuBookIcon />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => {
                    changeData("infoOpen", true);
                    changeData("info", { type: "map", item }, true);
                  }}
                >
                  <MapIcon />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => {
                    changeData("infoOpen", true);
                    changeData("info", { type: "photo", item }, true);
                  }}
                >
                  <CameraAltIcon />
                </IconButton>
                <Divider />
                <Divider />
              </>
            );
          })
        )}

        <InfoDialog
          data={newData.info}
          open={newData.infoOpen}
          onClose={() => {
            changeData("info", null);
            changeData("infoOpen", false, true);
          }}
        />
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                Boolean(data) && data.foreclosures.pageCount
                  ? data.foreclosures.pageCount
                  : 1
              }
              size="large"
              color="primary"
              page={newData.page}
              onChange={(e, n) => {
                changeData("page", n, true);
              }}
            />
          </Grid>
        </CardActions>
      </>
    );
  }
}

function InfoDialog({ open, data, onClose = () => {} }) {
  const history = useHistory();
  if (data)
    switch (data.type) {
      case "simpleInfo":
        return (
          <Dialog open={open} onClose={onClose} fullWidth maxWidth={"xs"}>
            <DialogActions>
              <Grid container spacing={1}>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push(
                        `/console/sale-obj-search-results/${data.item.obj_no}`,
                        {
                          id: data.item.obj_no,
                        }
                      );
                    }}
                  >
                    打開物件詳細資料
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(
                        `https://www.google.com/search?q=${data.item.obj_debtor}`,
                        "_blank",
                        "noopener"
                      );
                    }}
                  >
                    搜尋債務人
                  </Button>
                </Grid>
                <Grid item>
                  <IconButton size="medium" onClick={onClose}>
                    <HighlightOffIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogActions>
            <DialogContent dividers>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Grid container spacing={1} direction="row">
                    <Grid container xs={8}>
                      <Typography color="primary">投標日:</Typography>
                      <Typography>
                        {moment(data.item.obj_date_ymd).format("YYYY-MM-DD") +
                          "\u2002" +
                          moment(data.item.obj_date_hi).format("HH:mm")}
                      </Typography>
                    </Grid>
                    <Grid container xs={4}>
                      <Typography color="primary">拍次:</Typography>
                      <Typography>{data.item.obj_time}</Typography>
                    </Grid>
                    <Grid container xs={4}>
                      <Typography color="primary">總建坪:</Typography>
                      <Typography>
                        {data.item.obj_type === "L"
                          ? 0
                          : data.item.obj_total_floor}
                      </Typography>
                    </Grid>
                    <Grid container xs={4}>
                      <Typography color="primary">地坪:</Typography>
                      <Typography>{data.item.obj_land_floor}</Typography>
                    </Grid>
                    <Grid container xs={4}>
                      <Typography color="primary">主建坪:</Typography>
                      <Typography>{data.item.obj_build_floor}</Typography>
                    </Grid>
                    <Grid container xs={4}>
                      <Typography color="primary">附建坪:</Typography>
                      <Typography>{data.item.obj_s_floor}</Typography>
                    </Grid>
                    <Grid container xs={4}>
                      <Typography color="primary">增建坪:</Typography>
                      <Typography>{data.item.obj_add_floor}</Typography>
                    </Grid>
                    <Grid container xs={4}>
                      <Typography color="primary">公設坪:</Typography>
                      <Typography>{data.item.obj_c_floor}</Typography>
                    </Grid>
                    <Grid container xs={8}>
                      <Typography color="primary">公告現值:</Typography>
                      <Typography>公告現值</Typography>
                    </Grid>
                    <Grid container xs={6}>
                      <Typography color="primary">保證金:</Typography>
                      <Typography>
                        {(data.item.obj_margin / 10000).toFixed(2) + "萬"}
                      </Typography>
                    </Grid>
                    <Grid container xs={6}>
                      <Typography color="primary">底價:</Typography>
                      <Typography>{data.item.obj_price + "萬"}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <CardContent>
                    <Grid container spacing={1}>
                      <Box display="flex" alignItems="center" direction="row">
                        <Box minWidth={100} maxWidth="100px">
                          <Typography>土地</Typography>
                          <Typography style={{ color: "#3d5afe" }}>
                            {data.item.obj_land_floor === 0
                              ? "建坪:" + 0
                              : "建坪:" +
                                (
                                  data.item.obj_price / data.item.obj_land_floor
                                ).toFixed(2) +
                                "萬" +
                                "\n"}
                          </Typography>
                          <Typography style={{ color: "#3d5afe" }}>
                            {data.item.obj_total_floor === 0
                              ? "地坪:" + 0
                              : "地坪:" +
                                (
                                  data.item.obj_price /
                                  data.item.obj_total_floor
                                ).toFixed(2) +
                                "萬"}
                          </Typography>
                        </Box>
                        <Divider orientation="vertical" flexItem />
                        {"\u2002"}
                        <Box>
                          <Typography>
                            {data.item.obj_land_data?.replace(/<br>/g, "")}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </CardContent>
                  <Divider />
                  <CardContent>
                    <Grid container spacing={1}>
                      <Box display="flex" alignItems="center" direction="row">
                        <Box minWidth="100px" maxWidth="100px">
                          <Typography>建物</Typography>
                          <Typography style={{ color: "#3d5afe" }}>{`公設比:${
                            Boolean(data.item.obj_c_floor) &&
                            Boolean(data.item.obj_total_floor)
                              ? (
                                  (data.item.obj_c_floor /
                                    data.item.obj_total_floor) *
                                  100
                                ).toFixed()
                              : 0
                          }%`}</Typography>
                        </Box>
                        <Divider orientation="vertical" flexItem />
                        {"\u2002"}
                        <Box>
                          <Typography>
                            {"\u2002" +
                              data.item.obj_build_data?.replace(/<br>| /g, "")}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </CardContent>
                  <Divider />
                  <CardContent>
                    <Grid container spacing={1}>
                      <Box display="flex" alignItems="center" direction="row">
                        <Box minWidth={100}>
                          <Typography>公告筆錄</Typography>
                        </Box>
                        <Divider orientation="vertical" flexItem />
                        {"\u2002"}
                        <Box>
                          <Typography>
                            {data.item.obj_bulletin_data?.replace(
                              /<br>| /g,
                              ""
                            )}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </CardContent>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        );
      case "map":
        return (
          <Dialog open={open} onClose={onClose} fullWidth maxWidth={"xs"}>
            <DialogActions>
              <Grid container spacing={1} justifyContent="flex-end">
                <Grid item>
                  <IconButton size="medium" onClick={onClose}>
                    <HighlightOffIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogActions>
            <DialogContent dividers>
              <Map
                height={"200px"}
                direction={"column"}
                sm={12}
                mapData={{
                  obj_type: data.item.obj_type,
                  obj_city: data.item.obj_city,
                  obj_area: data.item.obj_area,
                  obj_address: data.item.obj_address,
                  obj_section: data.item.obj_section,
                  obj_section_s: data.item.obj_section_s,
                  obj_landno: data.item.obj_landno,
                }}
              />
            </DialogContent>
          </Dialog>
        );
      case "photo":
        return (
          <Dialog open={open} onClose={onClose} fullWidth maxWidth={"xs"}>
            <DialogActions>
              <Grid container spacing={1} justifyContent="flex-end">
                <Grid item>
                  <IconButton size="medium" onClick={onClose}>
                    <HighlightOffIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogActions>
            <DialogContent dividers>
              <CarouselImages data={data.item.images} />
            </DialogContent>
          </Dialog>
        );
      default:
        return null;
    }
  else return null;
}

function CarouselImages({ data }) {
  const [imageIndex, setImageIndex] = useState(0);
  const isTablet = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  // 輪播圖
  const [images, setImages] = useState([]);
  useEffect(() => {
    setImages([]);
    if (data?.length > 0) {
      let newImages = [];
      data?.forEach((item) => {
        newImages.push(item.imageUrl);
      });
      setImages(newImages);
    }
  }, [data]);
  if (images.length > 0) {
    return (
      <Box>
        <Container maxWidth="sm">
          <Carousel
            autoPlay
            showThumbs={false}
            infiniteLoop={true}
            interval={3000}
            //emulateTouch={true}
            showArrows={false}
            selectedItem={imageIndex}
            onChange={setImageIndex}
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              textAlign: isTablet ? "center" : "",
              position: "relative",
            }}
          >
            {images.map((item, index) => (
              <>
                <img
                  src={item}
                  key={index}
                  style={{
                    // 如果要完整顯示改成contain
                    objectFit: "cover",
                    width: "100%",
                    // height: isPhone ? "300px" : isTablet ? "550px" : "600px",
                    maxHeight: "200px",
                    borderRadius: "10px",
                    padding: "5px",
                  }}
                />
              </>
            ))}
          </Carousel>
        </Container>
      </Box>
    );
  } else {
    return null;
  }
}
